import { render, staticRenderFns } from "./RoundCmp.vue?vue&type=template&id=5a3e2450&scoped=true&"
import script from "./RoundCmp.vue?vue&type=script&lang=js&"
export * from "./RoundCmp.vue?vue&type=script&lang=js&"
import style0 from "./RoundCmp.vue?vue&type=style&index=0&id=5a3e2450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e2450",
  null
  
)

export default component.exports